import { req } from "./transport";

export type ContractActivityDirection = "newest" | "oldest";
export type ActivityTarget = { kind: "contract" | "project" | "quotation" | "rfq_items" | "job"; id: string };
export type ActivitySource = { kind: "project" | "quotation" | "rfq_items"; id: string };
export type ContractActivityEvent = {
  id: string;
  action: string;
  title: string;
  actionAt: string | null;
  actionDate: string | null;
  timePrecision: "instant" | "date" | "unknown";
  actor: { userId: number | null; name: string | null; role: string | null; companyId: string | null; system: boolean };
  amount: number | null;
  stageId: string | null;
  stageLabel: string | null;
  proposalId: string | null;
  proposalVersion: number | null;
  documentId: string | null;
  selectionId: string | null;
  sourceType: string;
  sourceId: string | null;
  dealingType: string;
  dealingId: string;
  recordedAt: string;
  legacy: boolean;
  outcome: string | null;
  bookingServiceId: string | null;
  source: ActivitySource | null;
};
export type ContractActivityPage = {
  contractId?: string | null;
  hasAcceptedAgreement?: boolean;
  events: ContractActivityEvent[];
  nextCursor: string | null;
  cutoff: string;
  snapshot?: string;
  coverage: { limited: boolean; from: string | null; families: string[]; pendingFamilies?: string[] };
};

export const contractActivityApi = {
  activity(target: ActivityTarget, direction: ContractActivityDirection, cursor?: string | null, snapshot?: string) {
    const query = new URLSearchParams({ direction });
    if (cursor) query.set("cursor", cursor);
    if (snapshot) query.set("snapshot", snapshot);
    const path = target.kind === "job" ? `/engagements/${encodeURIComponent(target.id)}/activity`
      : target.kind === "contract" ? `/contracts/${encodeURIComponent(target.id)}/activity`
      : target.kind === "project" ? `/project-agreements/${encodeURIComponent(target.id)}/activity`
      : `/contracts/activity/${target.kind}/${encodeURIComponent(target.id)}`;
    return req<ContractActivityPage>(`${path}?${query}`, {}, { rejectUnauthorized: true });
  },
  activitySource(source: ActivitySource) {
    return req<{ source: ActivitySource; target: ActivityTarget; threadId: string; messageId: string; proposalId: string;
      proposalVersion: number | null; documentId: string | null }>(`/contracts/activity/source/${source.kind}/${encodeURIComponent(source.id)}`, {}, { rejectUnauthorized: true });
  },
  /** A cursor pins the authorized record/profile, direction and history snapshot.
   * Later actions require a fresh first page; operational request controls use /events. */
  contractActivity(id: string, direction: ContractActivityDirection, cursor?: string | null) {
    const query = new URLSearchParams({ direction });
    if (cursor) query.set("cursor", cursor);
    return req<ContractActivityPage>(`/contracts/${encodeURIComponent(id)}/activity?${query}`, {}, { rejectUnauthorized: true });
  },
};
